import React, { useState } from "react";
import styled from "styled-components";
import addCursoButton from "../../../assets/addCursoButton.png";
import { Link } from "react-router-dom";
import { SORT_OPTIONS_CAMPIS } from "../../../utils/sortFilters";
import SearchBar from "../../common/Search/SearchBar";

const HeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 12px 40px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
`;

const Title = styled.div`
  margin-right: 60px;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  font-weight: 500;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6AB8A8;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;

  img {
    margin-left: 8px;
    width: 18px;
    height: 18px;
  }

  span {
    font-size: 14px;
    margin-left: 8px;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SortDropdownWrapper = styled.div`
  position: relative;
`;

const SortDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 1000;
  min-width: 150px;
`;

const SortOption = styled.div`
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  color: black;
  font-size: 13px;
  text-align: center;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const CampisCadastradosHeader = ({ user, onSortChange, searchValue = '', onSearchChange }) => {
  const [showSortDropdown, setShowSortDropdown] = useState(false);

  const handleSortSelect = (order) => {
    if (onSortChange) {
      onSortChange(order);
    }
    setShowSortDropdown(false);
  };

  return (
    <HeaderBar>
      <TitleGroup>
        <Title>
          CAMPIS
        </Title>
        {user && user.cargoId === 2 && (
          <Link to="/CadastroCampis" style={{ textDecoration: "none" }}>
            <Button>
              Cadastrar
              <img src={addCursoButton} alt="Cadastrar" />
            </Button>
          </Link>
        )}
        <SortDropdownWrapper>
          <Button onClick={() => setShowSortDropdown(!showSortDropdown)}>
            Ordenar
            <span className="material-symbols-outlined">toc</span>
          </Button>
          {showSortDropdown && (
            <SortDropdown>
              {SORT_OPTIONS_CAMPIS.map((option) => (
                <SortOption
                  key={option.value}
                  onClick={() => handleSortSelect(option.value)}
                >
                  {option.label}
                </SortOption>
              ))}
            </SortDropdown>
          )}
        </SortDropdownWrapper>
      </TitleGroup>

      <SearchWrapper>
        <SearchBar
          placeholder="Pesquisar por campi"
          style={{ backgroundColor: "#fafafa", borderColor: "#ddd" }}
          value={searchValue}
          onChange={(event) => onSearchChange?.(event.target.value)}
        />
      </SearchWrapper>
    </HeaderBar>
  );
};

export default CampisCadastradosHeader;
